var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg021Stop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,352c11.046,0,20-8.954,20-20V80c0-44.112-35.888-80-80-80H80C35.888,0,0,35.888,0,80v352c0,44.112,35.888,80,80,80 h352c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40H80 c-22.056,0-40-17.944-40-40V80c0-22.056,17.944-40,40-40h352c22.056,0,40,17.944,40,40v252C472,343.046,480.954,352,492,352z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg021Stop);
export default __webpack_public_path__ + "static/media/021-stop.95e876ffdfc3bd4d24c8b1df83f72638.svg";
export { ForwardRef as ReactComponent };